<div class="bg-dark min-h-screen">
  <div class="container mx-auto px-4 py-16 text-light">
    <div class="max-w-4xl mx-auto">
      <h1 class="text-4xl md:text-5xl font-bold mb-6 text-primary text-center">Algemene Voorwaarden</h1>
      <p class="text-lg mb-12 text-center text-gray-400">
        Laatst bijgewerkt: {{ lastUpdated }}
      </p>

      <div class="space-y-8">
        <section class="bg-dark-light p-8 rounded-lg border border-light/10">
          <div class="flex items-center mb-4">
            <span class="bg-primary/20 text-primary font-bold text-xl w-10 h-10 rounded-full flex items-center justify-center mr-4">1</span>
            <h2 class="text-2xl font-semibold text-light">Gebruik van de Website</h2>
          </div>
          <p class="text-gray-300 leading-relaxed ml-14">
            Door deze website te gebruiken, gaat u akkoord met deze algemene voorwaarden.
            Als u niet akkoord gaat met deze voorwaarden, dient u deze website niet te gebruiken.
          </p>
        </section>

        <section class="bg-dark-light p-8 rounded-lg border border-light/10">
          <div class="flex items-center mb-4">
            <span class="bg-primary/20 text-primary font-bold text-xl w-10 h-10 rounded-full flex items-center justify-center mr-4">2</span>
            <h2 class="text-2xl font-semibold text-light">Verantwoord Gokken</h2>
          </div>
          <p class="text-gray-300 leading-relaxed ml-14">
            Wij moedigen verantwoord gokken aan. Gokken kan verslavend zijn. Speel verantwoord.
            Deze website is alleen bedoeld voor personen van 18 jaar en ouder.
          </p>
        </section>

        <section class="bg-dark-light p-8 rounded-lg border border-light/10">
          <div class="flex items-center mb-4">
            <span class="bg-primary/20 text-primary font-bold text-xl w-10 h-10 rounded-full flex items-center justify-center mr-4">3</span>
            <h2 class="text-2xl font-semibold text-light">Affiliate Links</h2>
          </div>
          <p class="text-gray-300 leading-relaxed ml-14">
            Deze website bevat affiliate links. Wij kunnen een commissie ontvangen wanneer u
            via onze links een account opent bij een casino platform. Dit heeft geen invloed op
            onze beoordelingen of aanbevelingen.
          </p>
        </section>
      </div>
    </div>
  </div>
</div>

